import { createContext, useContext, useEffect } from "react";
import { useUser } from "./user";
import { useRest, useRestCall } from "../common/rest";
import { ULoading } from "../common/ui.page";


const AdminContext = createContext()
export function Admin(props) {
    const { ...rest } = props;
    const user = useUser()
    const [crusades, reload] = useRest('admin/crusade/list')
    const [call] = useRestCall(reload)

    if (!user) {
        return <ULoading />
    }

    if (!user.admin) {
        return <></>
    }

    if (!crusades) {
        return <ULoading />
    }

    return <AdminContext.Provider
        value={{
            crusades,
            reload,
            call,
        }}
        {...rest}
    />
}

export function AdminCrusade(props) {
    const { id, ...rest } = props;
    const ctx = useContext(AdminContext)
    const [crusade, reload_c] = useRest('admin/crusade/' + id + '/info')
    const [call] = useRestCall(reload)

    function reload() {
        ctx.reload();
        reload_c();
    }

    useEffect(() => {
        const interval = setInterval(reload, 5000)
        return () => clearTimeout(interval)
    }, [])

    if (!crusade) {
        return <ULoading />
    }

    return <AdminContext.Provider
        value={{
            ...ctx,
            reload,
            crusade,
            call,
        }}
        {...rest}
    />
}

export function useAdmin() {
    const { crusade, crusades, reload, call } = useContext(AdminContext)

    function newCrusade(data) {
        call('admin/crusade/new', data)
    }
    function removeCrusade(cid) {
        call('admin/crusade/' + cid + '/remove')
    }
    function addPlayer() {
        call('admin/crusade/' + crusade.id + '/player/add')
    }
    function removePlayer(id) {
        call('admin/crusade/' + crusade.id + '/player/' + id + '/remove')
    }
    function editMatchField(id, field, value) {
        call('admin/crusade/' + crusade.id + '/match/' + id + '/edit/' + field, value)
    }
    function removeMatch(id) {
        call('admin/crusade/' + crusade.id + '/match/' + id + '/remove')
    }
    function completeMatch(id, rewards, winners) {
        call('admin/crusade/' + crusade.id + '/match/' + id + '/complete', {
            rewards,
            winners
        })
    }


    return {
        crusade,
        crusades,
        reload,

        newCrusade,
        removeCrusade,
        editMatchField,
        removeMatch,
        completeMatch,

        call,

        addPlayer,
        removePlayer,
    }
}